export const IMAGE_SIZE_LIMIT = 4000 as const;
export const DEFAULT_HOST = "a.storyblok.com" as const;
